import { useField } from 'formik';
import { Flex } from '@chakra-ui/react';
import { Switch } from '@kula-ai/components';
import { Stars03 } from '@kula-ai/icons-core';
import { KText } from '@/ui-library/components/text';

interface NoteTakerFieldProps {
  name: string;
  isNoteTakerMandatory: boolean;
}

export const NoteTakerField = ({
  name,
  isNoteTakerMandatory,
}: NoteTakerFieldProps) => {
  const [field, , helpers] = useField(name);
  const { setValue } = helpers;
  const { value } = field;

  const leftSection = () => {
    return (
      <Flex flexDir="column" gap="6px" flex="1">
        <Flex alignItems="center" gap="6px">
          <Stars03 size={16} className="!text-primary-500" />
          <KText size="sm-semi-bold" color="primary-500">
            Enable AI notetaker?
            {isNoteTakerMandatory && (
              <KText as="span" color="red.500" fontSize="14px">
                *
              </KText>
            )}
          </KText>
        </Flex>

        <KText size="sm-regular" color="secondary-700">
          The AI Notetaker automatically captures key points and summaries
          during meetings.
        </KText>
      </Flex>
    );
  };

  return (
    <Flex
      bg="secondary-25"
      borderRadius="8px"
      p="12px"
      justifyContent="space-between"
      alignItems="center"
      gap="6px"
    >
      {leftSection()}
      <Switch
        defaultChecked={isNoteTakerMandatory}
        disabled={isNoteTakerMandatory}
        size="md"
        checked={Boolean(value)}
        onCheckedChange={(checked) => setValue(Boolean(checked))}
      />
    </Flex>
  );
};
